export default {
  sections: {
    order_summary: 'Totaal bestelling',
  },
  labels: {
    add_items: 'Voeg items toe om te beginnen',
    item_count_one: '{{count}} item',
    item_count_other: '{{count}} items',
  },
  buttons: {
    return: 'Terug naar bestellingsoverzicht',
  },
};
